import 'react-dates/initialize';
import React, { Component } from 'react';
import moment from 'moment-timezone'
import { 
    DateRangePicker, 
    SingleDatePicker, 
    DayPickerRangeController, 
    DayPickerSingleDateController } from 'react-dates';
import css from 'react-dates/lib/css/_datepicker.css';
import css2 from './custom-date-picker.css';

export default class CFDateRangePicker extends Component {
    constructor(props) {
        super(props);

        this.state = {
            singleDate: this.props.initialDate ? this.props.initialDate : null,
            startDate: this.props.startDate,
            endDate: this.props.endDate,
            availableStart: this.props.availableStart,
            availableEnd: this.props.availableEnd,
            focusedInput: this.props.startDate,
            dateRangeFocus: null,
            initialDate: this.props.initialDate
        }

        this.onDateRangeChange = this.onDateRangeChange.bind(this);
        this.onDatesChange = this.onDatesChange.bind(this);
        this.onDateChange = this.onDateChange.bind(this);
        this.isDayBlocked = this.isDayBlocked.bind(this);
        this.onStartDateOffSetSelected = this.onStartDateOffSetSelected.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.isSingleDate)
            this.setState({ singleDate: nextProps.singleDate });
        if (this.props.isSingleDayPicker)
            this.setState({ singleDate: nextProps.singleDate });
        else
            this.setState({ 
                startDate: nextProps.startDate, 
                endDate: nextProps.endDate,
                focusedInput:nextProps.startDate 
            });
    }

    onStartDateOffSetSelected(startDateOffset){
        if(this.props.onStartDateOffSetSelected)
            return this.props.onStartDateOffSetSelected(startDateOffset)      
    }

    onDateRangeChange(startDate, endDate) {
        if (this.props.onDatesChange)
            this.props.onDatesChange(startDate, endDate);        
    }

    onDatesChange(startDate, endDate) {
        if (this.props.getDates)
            this.props.getDates(startDate, endDate);
    }

    onDateChange(date) {
        const selectedDate = (!!date && date.isSame(this.state.singleDate, 'day')) ? null : date;
        if (this.props.onDateChange)
            this.props.onDateChange(selectedDate);

        this.setState({ singleDate: selectedDate });
    }

    isDayBlocked(date) {
        if (this.props.isDayBlocked)
            return this.props.isDayBlocked(date);
        else
            return false;
    }
    onDateRangeClose(){
        if(this.props.onClose)
            this.props.onClose();
    }

    isDayHighlighted(date) {
        if (this.props.isDayHighlighted)
            return this.props.isDayHighlighted(date);
        else
            return false;
    }
    onDateRangeClose(){
        if(this.props.onClose)
            this.props.onClose();
    }

    render() {
        return (
            <div className={this.props.className}> 
                { 
                    this.props.isSingleDate ? 
                        <SingleDatePicker
                            firstDayOfWeek={1}
                            placeholder="Select Date"
                            showDefaultInputIcon
                            hideKeyboardShortcutsPanel
                            date={this.state.singleDate} // momentPropTypes.momentObj or null
                            onDateChange={date => this.onDateChange(date)} // PropTypes.func.isRequired
                            focused={this.state.focused} // PropTypes.bool
                            onFocusChange={({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
                            id={this.props.id ? this.props.id : "single_date_id"} // PropTypes.string.isRequired,
                            isDayBlocked={(date) => this.isDayBlocked(date)}
                            isOutsideRange={() => this.props.isOutsideRange}
                        />
                        : this.props.isSingleDayPicker ?
                            <DayPickerSingleDateController  
                                date={this.state.singleDate}// momentPropTypes.momentObj or null,                                                                                          
                                onDateChange={date => this.onDateChange(date)} // PropTypes.func.isRequired
                                onFocusChange={({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
                                hideKeyboardShortcutsPanel
                                noBorder 
                                firstDayOfWeek={1}
                                isDayHighlighted={date => this.isDayHighlighted(date)}
                                isOutsideRange={date => {
                                    if (this.props.availableEnd && date.isSame(this.props.availableEnd, 'day'))
                                        return false;
                                    else if(this.props.availableStart && date.isSame(this.props.availableStart, 'day'))
                                        return false;
                                    else if ((date.tz("America/New_York") <= this.props.availableStart) || (date > this.props.availableEnd))
                                        return true;
                                    }
                                }
                            />
                        :this.props.isRangeController ?
                            <DayPickerRangeController
                                // date = {this.state.singleDate}
                                startDate={this.state.startDate} // momentPropTypes.momentObj or null,                            
                                endDate={this.state.endDate}
                                hideKeyboardShortcutsPanel
                                numberOfMonths={this.props.numberOfMonths ? this.props.numberOfMonths : 2}
                                noBorder={false}
                                firstDayOfWeek={1}
                                onDatesChange={({ startDate, endDate }) => this.onDateRangeChange(startDate, endDate)} // PropTypes.func.isRequired,
                                // focusedInput={this.state.startDate} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                                onFocusChange={focusedInput => this.setState({ focusedInput })} // PropTypes.func.isRequired,
                                // startDateOffset={startDateOffset => {
                                //     this.setState({singleDate: startDateOffset.clone()})
                                //     return startDateOffset.isoWeekday(1)
                                // }}
                                startDateOffset={startDateOffset => this.onStartDateOffSetSelected(startDateOffset)}
                                endDateOffset={endDateOffset => {
                                    return endDateOffset.isoWeekday(7)
                                }}
                            />
                            :
                            <DateRangePicker
                                firstDayOfWeek={1}
                                startDate={this.props.startDate} // momentPropTypes.momentObj or null,
                                startDateId="start_date_id" // PropTypes.string.isRequired,
                                endDate={this.props.endDate} // momentPropTypes.momentObj or null,
                                endDateId="end_date_id" // PropTypes.string.isRequired,
                                onDatesChange={({ startDate, endDate }) => this.onDatesChange(startDate, endDate)} // PropTypes.func.isRequired,
                                isDayBlocked={(date) => this.isDayBlocked(date)}
                                isDayHighlighted={date => {
                                    if (date.tz("America/New_York").isSame(this.state.endDate, 'day') || date.tz("America/New_York").isSame(this.state.startDate, 'day')) {
                                        return true;
                                    }
                                  }
                                }
                                focusedInput={this.state.dateRangeFocus} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                                onFocusChange={focusedInput => this.setState({ dateRangeFocus:  focusedInput})} // PropTypes.func.isRequired,
                                isOutsideRange={date => {
                                    if (date.isSame(this.props.availableEnd, 'day'))
                                        return false;
                                    else if ((date.tz("America/New_York") <= this.props.availableStart) || (date > this.props.availableEnd))
                                        return true;
                                    }
                                }
                                daySize={37}
                                minimumNights={0}
                                hideKeyboardShortcutsPanel
                                keepOpenOnDateSelect
                                showDefaultInputIcon
                                small
                                disabled={this.props.disabled? true: false}   
                                onClose={() => this.onDateRangeClose()}  
                                // autoFocus                           
                            />
                }
            </div>


        );
    }
}



// WEBPACK FOOTER //
// ./src/date-picker/date-picker.js